import { HttpLink } from 'apollo-link-http';
import fetch from 'unfetch';

const linkHttp = (uri = '/graphql-gateway') =>
  new HttpLink({
    uri,
    fetch,
  });

export default linkHttp;
